export const AZET = "Azet";
export const ADMINISTRATOR = "Administrator";
export const COINVESTOR = "CoInvestor";
export const FACILITY = "Facility";
export const INVESTOR = "Investor";
export const PARTNER = "Partner";
export const PARTNERADMIN = "PartnerAdmin";
export const TRANSACTIONADMIN = "TransactionAdmin";
export const FUNDADMIN = "FundAdmin";